const translation = {
  daysInWeek: {
    Tue: '星期二',
    Wed: '星期三',
    Fri: '自由',
    Mon: '懷念',
    Sun: '太陽',
    Sat: '星期六',
    Thu: '星期四',
  },
  months: {
    January: '一月',
    June: '六月',
    March: '三月',
    February: '二月',
    August: '八月',
    April: '四月',
    May: '五月',
    July: '七月',
    November: '十一月',
    December: '十二月',
    September: '九月',
    October: '十月',
  },
  operation: {
    cancel: '取消',
    now: '現在',
    ok: '好',
    pickDate: '選擇日期',
  },
  title: {
    pickTime: '選擇時間',
  },
  defaultPlaceholder: '選擇一個時間...',
}

export default translation
